// Dev auth helpers. Active when VITE_DEV_AUTH=true. Stores the chosen user id
// in localStorage; the API client and guards read from here. Off in
// production builds. Users must exist in the DB (`npm run seed:dev`).

import type { UserRole } from "@agp/shared";

const STORAGE_KEY = "agp.devAuth";

export const DEV_AUTH_ENABLED =
  (import.meta.env.VITE_DEV_AUTH ?? "").toString().toLowerCase() === "true";

export interface DevAuthState {
  clerkUserId: string;
  role: UserRole;
  email: string;
}

export interface DevAuthUser extends DevAuthState {
  password: string;
  displayName: string;
}

export const DEV_USERS: DevAuthUser[] = [
  {
    clerkUserId: "dev_admin_001",
    role: "admin",
    email: "admin@agp.test",
    password: "admin123",
    displayName: "Admin",
  },
  {
    clerkUserId: "dev_user_001",
    role: "user",
    email: "annick@agp.test",
    password: "annick123",
    displayName: "Annick (formatter)",
  },
  {
    clerkUserId: "dev_user_002",
    role: "user",
    email: "shane@agp.test",
    password: "shane123",
    displayName: "Shane (PM)",
  },
];

export function findDevUser(email: string, password: string): DevAuthUser | null {
  const lower = email.trim().toLowerCase();
  return (
    DEV_USERS.find((u) => u.email.toLowerCase() === lower && u.password === password) ?? null
  );
}

export function getDevAuth(): DevAuthState | null {
  if (!DEV_AUTH_ENABLED) return null;
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as DevAuthState;
  } catch {
    return null;
  }
}

export function setDevAuth(state: DevAuthState): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function clearDevAuth(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}
